<template>
  <div style="padding: 0 10px">
    <From @search="searchCall" />
    <WmsTable :columns="columns" :dataSource="dataSource" @pageChange="pageChangeCall" :isPagination="query" :hasHeader="false">
      <ImgView slot="productImgAction" slot-scope="{text, record, index}" :src="text"></ImgView>
      <a slot="action" slot-scope="{text, record, index}" href="javaScript:;" @click="abnormalHandler(record)"
        v-if="!'12'.includes(record.signType)">异常登记</a>
    </WmsTable>
    <el-dialog title="异常处理" width="1400px" :visible.sync="abnormalInfo.visible" :show-close="false"
      :confirm-loading="abnormalInfo.loading" @close="handleCancel" :footer="null" ref="isreceipt">
      <el-card v-if="abnormalInfo.visible">
        <Content :abnormal-type="abnormalInfo.types" :uploadId="abnormalInfo.expressNo" btnTitle="异常上报采购"
          @submitAbnormal="abnormalCall" :isreceipt="true" abnormal="Purchase" />
      </el-card>
    </el-dialog>
  </div>
</template>

<script>
import WmsTable from "@/components/WmsTable";
import ImgView from "@/components/ImgView";
import Content from "@/views/inHouse/components/Abnormal/Content";
import { abnormalPurchase } from "@/types";
import { columns } from "@/views/inventoryDetails/receiptLog/indexData";
import From from "@/views/inventoryDetails/receiptLog/components/From";
import { signRecordPage } from "@/apis/inventoryDetails"
import { createSignFlow,imgByCode } from "@/apis/inHouse";
export default {
  title: '快递签收记录',
  name: "ReceiptLog",
  components: {
    WmsTable,
    From,
    ImgView,
    Content
  },
  data() {
    return {
      columns,
      query: {
        current: 1,
        pageSize: 10,
        total: 0
      },
      dataSource: [],
      abnormalInfo: {
        visible: false,
        loading: false,
        types: abnormalPurchase.slice(0, 1),
        data: null,
        expressNo: "",
      },
    }
  },
  mounted() {
  },
  methods: {
    pageChangeCall: function (payload) {
      const { current, pageSize } = payload
      this.query.current = current
      this.query.pageSize = pageSize
      this.getDataSource()
    },
    searchCall: function (fromData) {
      this.formInline = fromData
      this.query.current = 1;
      this.query.total = 1;
      this.getDataSource()
    },
    getDataSource: function () {
      let params = {
        pageSize: this.query.pageSize,
        pageNum: this.query.current,
        ...this.formInline
      }
      signRecordPage(params).then(({ code, data }) => {
        if (code === 0) {
          this.dataSource = data.records
          this.query.total = data.total
        }
      })
    },
    handleCancel: function () {
      this.abnormalInfo.visible = false;
    },
    abnormalHandler: function (record) {
      console.log(this);
      this.abnormalInfo.expressNo = record.expressNo;
      this.abnormalInfo.visible = true;
      // this.abnormalInfo.data = record;
    },
    abnormalCall: function (payload) {
      if (payload.expressPhone == "") {
        this.$message.warning("请输入手机号");
        return false;
      }
      let params = {
        expressNo: payload.qrCode,
        expressPhone: payload.expressPhone,
      };
      // return;
      imgByCode({ picRelation: payload.qrCode }).then(({ code, data }) => {
        if (code === 0) {
          if (data.length > 0) {
            createSignFlow(params).then(({ code, data }) => {
              if (code === 0) {
                this.$message.success("成功");
                this.handleCancel()
                this.getDataSource()
              }
            });
          } else {
            this.$message.warning("请先上传图片");
          }
        }
      });
    }
  }
}
</script>

<style scoped>
</style>